import Vue from "vue";
import SettingForm from "./src/SettingForm.vue";
import BlackBoxTag from "./src/BlackBoxTag.vue";
import BindBlabla from "./src/BindBlabla.vue";
import BlackBoxDetail from "./src/BlackBoxDetail/index.vue";

function openSetting() {
  const el = document.createElement("div");
  document.body.append(el);
  const VueClass = Vue.extend(SettingForm);
  const vm = new VueClass({ parent: window.app });
  vm.$on("resolve", () => {
    console.log("resolve");
    vm.$el.remove();
    vm.$destroy();
  });
  vm.$on("reject", () => {
    console.log("reject");
    vm.$el.remove();
    vm.$destroy();
  });
  vm.$mount(el);
}

function bindBlabla() {
  const el = document.createElement("div");
  document.body.append(el);
  const VueClass = Vue.extend(BindBlabla);
  const vm = new VueClass({ parent: window.app });
  vm.$on("resolve", () => {
    console.log("resolve");
    vm.$el.remove();
    vm.$destroy();
  });
  vm.$on("reject", () => {
    console.log("reject");
    vm.$el.remove();
    vm.$destroy();
  });
  vm.$mount(el);
}

function blackBoxDetail(propsData) {
  const el = document.createElement("div");
  document.body.append(el);
  const VueClass = Vue.extend(BlackBoxDetail);
  const vm = new VueClass({ parent: window.app, propsData });
  vm.$on("resolve", () => {
    console.log("resolve");
    vm.$el.remove();
    vm.$destroy();
  });
  vm.$on("reject", () => {
    console.log("reject");
    vm.$el.remove();
    vm.$destroy();
  });
  vm.$mount(el);
}

export { openSetting, bindBlabla, blackBoxDetail, BlackBoxTag };
